import React, { Fragment } from "react";
import PropTypes from "prop-types";
import BannerComponent from "../banner";
import "./styles.css";

const ServiciosComponent = (props) => {
  return (
    <Fragment>
      <div className="servicios-container">
        <BannerComponent
          idiomaNavegador={props.idiomaNavegador}
          servicios={props.servicios}
          componente={props.componente}
        ></BannerComponent>
      </div>
    </Fragment>
  );
};

ServiciosComponent.propTypes = {
  servicios: PropTypes.array,
  idiomaNavegador: PropTypes.string,
  componente: PropTypes.string,
};

export default ServiciosComponent;
